// extracted by mini-css-extract-plugin
module.exports = {"s101r4dd":"s101r4dd"};